import React, { CSSProperties } from 'react';
import { I18nTranslations } from '../../types';

export interface WelcomeScreenProps {
  /** Traduções */
  translations: I18nTranslations;
  /** Callback quando usuário clica em "Get Started" */
  onGetStarted: () => void;
  /** Estilos do tema */
  themeStyles?: {
    backgroundColor?: string;
    primaryColor?: string;
    textColor?: string;
  };
}

/**
 * Tela de boas-vindas exibida antes do chat
 */
export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  translations,
  onGetStarted,
  themeStyles = {},
}) => {
  const styles: Record<string, CSSProperties> = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      padding: '2rem',
      backgroundColor: themeStyles.backgroundColor || '#f9fafb',
      textAlign: 'center',
    },
    title: {
      fontSize: '1.75rem',
      fontWeight: 'bold',
      color: themeStyles.textColor || '#111827',
      marginBottom: '0.5rem',
    },
    subtitle: {
      fontSize: '1rem',
      color: themeStyles.textColor || '#6b7280',
      marginBottom: '2rem',
      maxWidth: '400px',
    },
    button: {
      backgroundColor: themeStyles.primaryColor || '#4f46e5',
      color: '#ffffff',
      border: 'none',
      borderRadius: '8px',
      padding: '0.75rem 2rem',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    buttonHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    },
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{translations.title}</h1>
      <p style={styles.subtitle}>{translations.subtitle}</p>
      <button
        style={{
          ...styles.button,
          ...(isHovered ? styles.buttonHover : {}),
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onGetStarted}
      >
        {translations.getStarted}
      </button>
    </div>
  );
};
